// Food / Baking category step images

import artisanPizzaCh2S1 from '@/assets/step-images/artisan-pizza-ch2-s1.jpg';
import artisanPizzaCh3S5 from '@/assets/step-images/artisan-pizza-ch3-s5.jpg';
import baristaArtCh1S1 from '@/assets/step-images/barista-art-ch1-s1.jpg';
import baristaArtCh3S5 from '@/assets/step-images/barista-art-ch3-s5.jpg';
import breadButterSpreadCh3S5 from '@/assets/step-images/bread-butter-spread-ch3-s5.jpg';
import chickenThreeSaucesCh3S3 from '@/assets/step-images/chicken-three-sauces-ch3-s3.jpg';
import chickenThreeSaucesCh3S5 from '@/assets/step-images/chicken-three-sauces-ch3-s5.jpg';
import dessertTastingPlateCh1S1 from '@/assets/step-images/dessert-tasting-plate-ch1-s1.jpg';
import dessertTastingPlateCh1S5 from '@/assets/step-images/dessert-tasting-plate-ch1-s5.jpg';
import dessertTastingPlateCh2S3 from '@/assets/step-images/dessert-tasting-plate-ch2-s3.jpg';
import dessertTastingPlateCh3S1 from '@/assets/step-images/dessert-tasting-plate-ch3-s1.jpg';
import dessertTastingPlateCh3S5 from '@/assets/step-images/dessert-tasting-plate-ch3-s5.jpg';
import giftableTreatsCh1S1 from '@/assets/step-images/giftable-treats-ch1-s1.jpg';
import giftableTreatsCh1S5 from '@/assets/step-images/giftable-treats-ch1-s5.jpg';
import giftableTreatsCh2S1 from '@/assets/step-images/giftable-treats-ch2-s1.jpg';
import giftableTreatsCh3S4 from '@/assets/step-images/giftable-treats-ch3-s4.jpg';
import homebrewCh2S5 from '@/assets/step-images/homebrew-ch2-s5.jpg';
import homebrewCh3S5 from '@/assets/step-images/homebrew-ch3-s5.jpg';
import homemadeChocolateCh3S3 from '@/assets/step-images/homemade-chocolate-ch3-s3.jpg';
import homemadeChocolateCh3S5 from '@/assets/step-images/homemade-chocolate-ch3-s5.jpg';
import infusedSodaCh1S1 from '@/assets/step-images/infused-soda-ch1-s1.jpg';
import infusedSodaCh3S4 from '@/assets/step-images/infused-soda-ch3-s4.jpg';
import pizzaThreeFlavorsCh1S1 from '@/assets/step-images/pizza-three-flavors-ch1-s1.jpg';
import pizzaThreeFlavorsCh2S4 from '@/assets/step-images/pizza-three-flavors-ch2-s4.jpg';
import pizzaThreeFlavorsCh3S4 from '@/assets/step-images/pizza-three-flavors-ch3-s4.jpg';
import signatureCookieCh2S1 from '@/assets/step-images/signature-cookie-ch2-s1.jpg';
import signatureCookieCh2S4 from '@/assets/step-images/signature-cookie-ch2-s4.jpg';
import signatureCookieCh3S1 from '@/assets/step-images/signature-cookie-ch3-s1.jpg';
import signatureCookieCh3S5 from '@/assets/step-images/signature-cookie-ch3-s5.jpg';
import sourdoughBreadCh1S5 from '@/assets/step-images/sourdough-bread-ch1-s5.jpg';
import sourdoughBreadCh3S2 from '@/assets/step-images/sourdough-bread-ch3-s2.jpg';
import sourdoughCookiesCh2S1 from '@/assets/step-images/sourdough-cookies-ch2-s1.jpg';
import sourdoughCookiesCh2S5 from '@/assets/step-images/sourdough-cookies-ch2-s5.jpg';
import sourdoughCookiesCh3S2 from '@/assets/step-images/sourdough-cookies-ch3-s2.jpg';
import sourdoughCookiesCh3S5 from '@/assets/step-images/sourdough-cookies-ch3-s5.jpg';
import sushiRollCh3S4 from '@/assets/step-images/sushi-roll-ch3-s4.jpg';
import sushiRollCh3S5 from '@/assets/step-images/sushi-roll-ch3-s5.jpg';
import threeCookiesCh3S1 from '@/assets/step-images/three-cookies-ch3-s1.jpg';
import threeCookiesCh3S3 from '@/assets/step-images/three-cookies-ch3-s3.jpg';
import threeCookiesCh3S5 from '@/assets/step-images/three-cookies-ch3-s5.jpg';

import regionalFoodTastingCh1S1 from '@/assets/step-images/regional-food-tasting-ch1-s1.jpg';
import regionalFoodTastingCh1S2 from '@/assets/step-images/regional-food-tasting-ch1-s2.jpg';
import regionalFoodTastingCh1S3 from '@/assets/step-images/regional-food-tasting-ch1-s3.jpg';
import regionalFoodTastingCh1S4 from '@/assets/step-images/regional-food-tasting-ch1-s4.jpg';
import regionalFoodTastingCh1S5 from '@/assets/step-images/regional-food-tasting-ch1-s5.jpg';
import regionalFoodTastingCh2S1 from '@/assets/step-images/regional-food-tasting-ch2-s1.jpg';
import regionalFoodTastingCh2S2 from '@/assets/step-images/regional-food-tasting-ch2-s2.jpg';
import regionalFoodTastingCh2S3 from '@/assets/step-images/regional-food-tasting-ch2-s3.jpg';
import regionalFoodTastingCh2S4 from '@/assets/step-images/regional-food-tasting-ch2-s4.jpg';
import regionalFoodTastingCh2S5 from '@/assets/step-images/regional-food-tasting-ch2-s5.jpg';
import regionalFoodTastingCh3S1 from '@/assets/step-images/regional-food-tasting-ch3-s1.jpg';
import regionalFoodTastingCh3S2 from '@/assets/step-images/regional-food-tasting-ch3-s2.jpg';
import regionalFoodTastingCh3S3 from '@/assets/step-images/regional-food-tasting-ch3-s3.jpg';
import regionalFoodTastingCh3S4 from '@/assets/step-images/regional-food-tasting-ch3-s4.jpg';
import regionalFoodTastingCh3S5 from '@/assets/step-images/regional-food-tasting-ch3-s5.jpg';

export const FOOD_BAKING_IMAGES: Record<string, string> = {
  'artisan-pizza-ch2-s1': artisanPizzaCh2S1,
  'artisan-pizza-ch3-s5': artisanPizzaCh3S5,
  'barista-art-ch1-s1': baristaArtCh1S1,
  'barista-art-ch3-s5': baristaArtCh3S5,
  'bread-butter-spread-ch3-s5': breadButterSpreadCh3S5,
  'chicken-three-sauces-ch3-s3': chickenThreeSaucesCh3S3,
  'chicken-three-sauces-ch3-s5': chickenThreeSaucesCh3S5,
  'dessert-tasting-plate-ch1-s1': dessertTastingPlateCh1S1,
  'dessert-tasting-plate-ch1-s5': dessertTastingPlateCh1S5,
  'dessert-tasting-plate-ch2-s3': dessertTastingPlateCh2S3,
  'dessert-tasting-plate-ch3-s1': dessertTastingPlateCh3S1,
  'dessert-tasting-plate-ch3-s5': dessertTastingPlateCh3S5,
  'giftable-treats-ch1-s1': giftableTreatsCh1S1,
  'giftable-treats-ch1-s5': giftableTreatsCh1S5,
  'giftable-treats-ch2-s1': giftableTreatsCh2S1,
  'giftable-treats-ch3-s4': giftableTreatsCh3S4,
  'homebrew-ch2-s5': homebrewCh2S5,
  'homebrew-ch3-s5': homebrewCh3S5,
  'homemade-chocolate-ch3-s3': homemadeChocolateCh3S3,
  'homemade-chocolate-ch3-s5': homemadeChocolateCh3S5,
  'infused-soda-ch1-s1': infusedSodaCh1S1,
  'infused-soda-ch3-s4': infusedSodaCh3S4,
  'pizza-three-flavors-ch1-s1': pizzaThreeFlavorsCh1S1,
  'pizza-three-flavors-ch2-s4': pizzaThreeFlavorsCh2S4,
  'pizza-three-flavors-ch3-s4': pizzaThreeFlavorsCh3S4,
  'regional-food-tasting-ch1-s1': regionalFoodTastingCh1S1,
  'regional-food-tasting-ch1-s2': regionalFoodTastingCh1S2,
  'regional-food-tasting-ch1-s3': regionalFoodTastingCh1S3,
  'regional-food-tasting-ch1-s4': regionalFoodTastingCh1S4,
  'regional-food-tasting-ch1-s5': regionalFoodTastingCh1S5,
  'regional-food-tasting-ch2-s1': regionalFoodTastingCh2S1,
  'regional-food-tasting-ch2-s2': regionalFoodTastingCh2S2,
  'regional-food-tasting-ch2-s3': regionalFoodTastingCh2S3,
  'regional-food-tasting-ch2-s4': regionalFoodTastingCh2S4,
  'regional-food-tasting-ch2-s5': regionalFoodTastingCh2S5,
  'regional-food-tasting-ch3-s1': regionalFoodTastingCh3S1,
  'regional-food-tasting-ch3-s2': regionalFoodTastingCh3S2,
  'regional-food-tasting-ch3-s3': regionalFoodTastingCh3S3,
  'regional-food-tasting-ch3-s4': regionalFoodTastingCh3S4,
  'regional-food-tasting-ch3-s5': regionalFoodTastingCh3S5,
  'signature-cookie-ch2-s1': signatureCookieCh2S1,
  'signature-cookie-ch2-s4': signatureCookieCh2S4,
  'signature-cookie-ch3-s1': signatureCookieCh3S1,
  'signature-cookie-ch3-s5': signatureCookieCh3S5,
  'sourdough-bread-ch1-s5': sourdoughBreadCh1S5,
  'sourdough-bread-ch3-s2': sourdoughBreadCh3S2,
  'sourdough-cookies-ch2-s1': sourdoughCookiesCh2S1,
  'sourdough-cookies-ch2-s5': sourdoughCookiesCh2S5,
  'sourdough-cookies-ch3-s2': sourdoughCookiesCh3S2,
  'sourdough-cookies-ch3-s5': sourdoughCookiesCh3S5,
  'sushi-roll-ch3-s4': sushiRollCh3S4,
  'sushi-roll-ch3-s5': sushiRollCh3S5,
  'three-cookies-ch3-s1': threeCookiesCh3S1,
  'three-cookies-ch3-s3': threeCookiesCh3S3,
  'three-cookies-ch3-s5': threeCookiesCh3S5,
};
